const options = {
  5: "bg-violet-700/5",
  10: "bg-violet-700/10",
  25: "bg-violet-700/25",
  50: "bg-violet-700/50",
  75: "bg-violet-700/75",
  90: "bg-violet-700/90",
  100: "bg-violet-700",
};

const from = {
  5: "from-violet-700/5",
  10: "from-violet-700/10",
  25: "from-violet-700/25",
  50: "from-violet-700/50",
  75: "from-violet-700/75",
  90: "from-violet-700/90",
  100: "from-violet-700",
};

export default function getBackgroundViolet700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
